<app-header></app-header>
<!-- Include Header -->
<main class="pages">
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center mob-column-reverse">
                <div class="col-md-6">
                    <h1 alt="collect data anywhere" class="h1-title">CViewSurvey features are tailored for every Industry and Business.
                    </h1>
                    <p class="sub-text mt-2">Powerful features of CViewSurvey are in line with the trusted C.A.A.G. (collect, analysis, act & grow) model, that caters to businesses of all sizes.</p>
                    <div class="mt-lg-5">
                        <a title="" class="btn btn-lg btn-success px-4 text-uppercase  mr-lg-2" data-toggle="modal" data-target="#callBack" id="callback"> Request a
                            Demo</a>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid w-100 mb-3 mb-lg-0" alt="Mobile App Survey" src="assets/features.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Hero Header -->


    <section class="mb-lg-5 py-lg-5">
        <div class="container ">
            <h3 alt="customer feedback" class="feature-main-heading font-weight-bold mb-lg-5 text-center border-bottom pb-3">Collecting Responses
            </h3>
            <div class="row">
                <div class="col-md-6">
                    <picture>
                        <img class="img-fluid w-100 mb-3 mb-lg-0" src="assets/collecting_responces.svg" alt="collect responses">
                    </picture>
                </div>
                <div class="col-md-6">
                    <ul class="list-unstyled mb-0 mb-lg-3">
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Offline & Online Mode:</h5>
                                <p class="sub-text text-justify">
                                    CViewSurvey offers the flexibility to work in online and offline mode, allowing you to collect data and responses anytime, anywhere.
                                </p>
                            </div>
                        </li>
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Supports iOS and Android Devices:</h5>
                                <p class="sub-text text-justify">
                                    With the help of CViewSurvey app, responses can be collected on iOS and Android devices.
                                </p>
                            </div>
                        </li>
                    </ul>
                    <ul class="list-unstyled mb-0 mb-lg-3">
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Unlimited Responses: </h5>
                                <p class="sub-text text-justify">
                                    Our application gives you access to collect unlimited responses for a better understanding of your customers or employees.
                                </p>
                            </div>
                        </li>
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Secure Cloud Based Services:</h5>
                                <p class="sub-text text-justify">
                                    Our app works on a SaaS based business model that allows you to store unlimited data safely and securely.
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <h3 alt="customer feedback" class="feature-main-heading font-weight-bold my-lg-5 text-center border-bottom pb-3">Survey Features
            </h3>
            <div class="row mob-column-reverse">
                <div class="col-lg-7">
                    <ul class="list-unstyled mb-0 mb-lg-3">
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Page Branching:</h5>
                                <p class="sub-text text-justify">
                                    Lets respondents skip one or more questions and jump to a different page.
                                </p>
                            </div>
                        </li>
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Customized Surveys:</h5>
                                <p class="sub-text text-justify">
                                    Personalize your surveys with custom background image or logo and improve your branding.
                                </p>
                            </div>
                        </li>
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Media as Question: </h5>
                                <p class="sub-text text-justify">
                                    This extensive feature allows respondents to upload media as a response.
                                </p>
                            </div>
                        </li>
                    </ul>
                    <ul class="list-unstyled mb-0 mb-lg-3">
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">White Labeled Surveys:</h5>
                                <p class="sub-text text-justify">
                                    Create branded surveys and forms that align with your brand identity.
                                </p>
                            </div>
                        </li>
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Pre-Designed Templates:</h5>
                                <p class="sub-text text-justify">
                                    We help you save your time and efforts by providing pre designed templates that cover all solutions.
                                </p>
                            </div>
                        </li>
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Conditional Questions Display:</h5>
                                <p class="sub-text text-justify">
                                    This features gives you the option of creating questions on the survey that dynamically adapts to your respondents answers.
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-5">
                    <picture>
                        <img class="img-fluid w-100 mb-3 mb-lg-0" src="assets/survey_features.svg" alt="survey features">
                    </picture>
                </div>
            </div>

            <h3 alt="customer feedback" class="feature-main-heading font-weight-bold my-lg-5 text-center border-bottom pb-3">Reports & Analytics
            </h3>
            <div class="row">
                <div class="col-md-6">
                    <picture>
                        <img class="img-fluid w-100 mb-3 mb-lg-0" src="assets/reports_analytics.svg" alt="Report Analytics">
                    </picture>
                </div>
                <div class="col-md-6">
                    <ul class="list-unstyled mb-0 mb-lg-3">
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Response Count Summary:</h5>
                                <p class="sub-text text-justify">
                                    The total response counts shows the grand total of responses all your users are able to collect for any particular survey.
                                </p>
                            </div>
                        </li>
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Net Promoter Score (NPS<sup>&reg;</sup>) Analysis:</h5>
                                <p class="sub-text text-justify">
                                    Get insights into your business’s promoters, detractors and passives and take action accordingly.
                                </p>
                            </div>
                        </li>
                    </ul>
                    <ul class="list-unstyled mb-0 mb-lg-3">
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Dashboard Analytics:</h5>
                                <p class="sub-text text-justify">
                                    Collect data and view its graphical representation in real time for 360<sup>&deg;</sup> assessment.
                                </p>
                            </div>
                        </li>
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Download Responses:</h5>
                                <p class="sub-text text-justify">
                                    Data or reports can be easily downloaded by the company admin in forms like Excel, CSV or PDF format.
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <h3 alt="customer feedback" class="feature-main-heading font-weight-bold my-lg-5 text-center border-bottom pb-3">Special Questions Type</h3>
            <div class="row mob-column-reverse">
                <div class="col-md-6 ">
                    <ul class="list-unstyled mb-0 mb-lg-3">
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Map Coordinates (GPS):</h5>
                                <p class="sub-text text-justify">Capture GPS location of the device while the survey is being taken.</p>
                            </div>
                        </li>
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Capture Media:</h5>
                                <p class="sub-text text-justify">Allows you to take photos, video or audio to enhance the survey experience.</p>
                            </div>
                        </li>
                    </ul>
                    <ul class="list-unstyled mb-0 mb-lg-3">
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Ranking & CX Metrics:</h5>
                                <p class="sub-text text-justify">Measure CX attributes using metrix like NPS<sup>&reg;</sup>, CSAT and CES.</p>
                            </div>
                        </li>
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Net Promoter Score (NPS<sup>&reg;</sup>):</h5>
                                <p class="sub-text text-justify">Measure customer loyalty by conducting NPS<sup>&reg;</sup> survey to gauge the likelihood of repeat business.</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-md-6 text-right">
                    <picture>
                        <img class="img-fluid w-100 mb-3 mb-lg-0" src="assets/special_questions_type.svg" alt="Survey app">
                    </picture>
                </div>
            </div>

            <h3 alt="customer feedback" class="feature-main-heading font-weight-bold my-lg-5 text-center border-bottom pb-3">Admin & User Roles
            </h3>
            <div class="row mb-lg-4 ">
                <div class="col-md-6">
                    <picture>
                        <img class="img-fluid w-100 mb-3 mb-lg-0" src="assets/admin_user_roles.svg" alt="admin user roles">
                    </picture>
                </div>
                <div class="col-md-6">
                    <ul class="list-unstyled mb-0 mb-lg-3">
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Allows Company Admin to Create & Manage Users:</h5>
                                <p class="sub-text text-justify">
                                    Company admins have the authority to create and manage users, which gives them the power to add, edit or delete users according to the need.
                                </p>
                            </div>
                        </li>
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Survey Creation:</h5>
                                <p class="sub-text text-justify">Company admin can create single or multiple surveys under one company account and can assign them to different users for collection of response.
                                </p>
                            </div>
                        </li>
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">Allow Company Admin to Manage Data:</h5>
                                <p class="sub-text text-justify">Only the company admin is authorised to view, manage and export data collected by the users. </p>
                            </div>
                        </li>
                        <li class="media mt-lg-4">
                            <div class="media-body">
                                <h5 class="font-weight-bold mt-0 mb-1">User Roles and Responsibilities:</h5>
                                <p class="sub-text text-justify">Users can only take responses to the survey and view their collected data. They can manage multiple surveys assigned by their company admin.</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <!-- Inner Content -->

    <section class="call-action bg-secondary py-lg-4 py-3">
        <div class="container-fluid">
            <div class="container">
                <div class="row">
                    <div class="col text-center">
                        <button class="px-5 btn text-uppercase btn-success btn-lg mb-lg-0 mb-3" data-toggle="modal" data-target="#callBack" id="callback">Request A demo</button>
                        <a class="px-5 btn text-uppercase btn-outline-success ml-lg-2 btn-lg" href="http://beta.cviewsurvey.com/login" target="_blank">Create Survey</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Footer button Content -->
</main>
<!-- Page Content -->

<app-footer></app-footer>
<!-- Include Footer -->